import { makeAutoObservable } from "mobx";

export type RandomSpaceAccessPublicConfig = {
  enabled: boolean;
  candidates: string[];
};

export class HomeModel {
  spaceIdInput = "";
  /** 空间 ID 校验失败时展示，如：您输入的空间ID不存在 */
  entranceError: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setSpaceIdInput(v: string) {
    this.spaceIdInput = v.replace(/\D/g, "").slice(0, 8);
    this.entranceError = null;
  }

  setEntranceError(msg: string | null) {
    this.entranceError = msg;
  }

  get isValidSpaceId(): boolean {
    return /^\d{8}$/.test(this.spaceIdInput);
  }
}
